module.exports = __webpack_public_path__ + "static/media/LUP_zast_L3.b9018d71.svg";